export default "__VITE_PUBLIC_ASSET__221010b0__"